import React from 'react';
import moment from 'moment';

const DateFormatter = ({ date, format = 'DD/MM/YYYY hh:mm A', formatTime, size=14 }) => {
  return (
    <div className='format-time' style={{ fontSize: size }}>
      <p>{moment(date).format(format)}</p>
      {formatTime && <p>{moment(date).format(formatTime)}</p>}
    </div>
  );
};

export default DateFormatter;